import { handleErrorInfo } from '../../utils';
import { Currencies } from '../interfaces';
import { PaymentIntegrationType } from './actions';
import { PaymentIntegrationState } from './interfaces';

const initialState: PaymentIntegrationState = {
  loading: false,
  error: false,
  errorInfo: undefined,
  apiKey: '',
  currencies: { USD: 'USD' },
  shopifyIntegration: {
    loading: false,
    error: false,
  },
};

const PaymentIntegration = (state = initialState, action: any) => {
  switch (action.type) {
    case PaymentIntegrationType.GET_INTEGRATION_KEYS: {
      return {
        ...state,
        loading: true,
        error: false,
        apiKey: '',
      };
    }
    case PaymentIntegrationType.GET_INTEGRATION_KEYS_SUCCESS: {
      const { apiKey, secretKey } = action.response;
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        apiKey,
        secretKey,
      };
    }
    case PaymentIntegrationType.GET_INTEGRATION_KEYS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(PaymentIntegrationType.GET_INTEGRATION_KEYS_ERROR, action.error),
        apiKey: '',
      };
    }
    case PaymentIntegrationType.GET_CURRENCIES_PI: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
        currencies: {},
      };
    }
    case PaymentIntegrationType.GET_CURRENCIES_PI_SUCCESS: {
      const currencies: Currencies = {};
      action.response.forEach((c: { currency: string }) => {
        currencies[c.currency] = c.currency;
      });
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: undefined,
        currencies,
      };
    }
    case PaymentIntegrationType.GET_CURRENCIES_PI_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(PaymentIntegrationType.GET_CURRENCIES_PI_ERROR, action.error),
        currencies: {},
      };
    }
    case PaymentIntegrationType.SET_SHOPIFY_TEST_MODE: {
      return {
        ...state,
        shopifyIntegration: {
          loading: true,
          error: false,
        },
      };
    }
    case PaymentIntegrationType.SET_SHOPIFY_TEST_MODE_SUCCESS: {
      return {
        ...state,
        shopifyIntegration: {
          loading: false,
          error: false,
        },
      };
    }
    case PaymentIntegrationType.SET_SHOPIFY_TEST_MODE_ERROR: {
      return {
        ...state,
        shopifyIntegration: {
          loading: false,
          error: true,
        },
      };
    }
    default:
      return state;
  }
};

export default PaymentIntegration;
